const stringToColor = (string) => {
  let hash = 0
  let i

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }
  /* eslint-enable no-bitwise */

  return color
}

export const stringAvatar = (name, sx = {}, noOfChar = 2) => {
  name = name.trim()
  const avatarBgColor =
    sx?.background && sx.background !== 'inherit'
      ? sx.background
      : stringToColor(name)
  const { background, bgcolor, ...avatarStyle } = sx
  let shortName = name
  if (noOfChar === 1) {
    shortName = name[0]
  } else if (name.indexOf(' ') >= 0) {
    shortName = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
  } else {
    shortName = name[0] + name[1]
  }
  return {
    sx: {
      ...sx,
      bgcolor: avatarBgColor,
    },
    style: {
      ...avatarStyle,
      backgroundColor: avatarBgColor,
    },
    children: shortName.toUpperCase(),
  }
}

export const timeAgo = (dateString) => {
  const date = new Date(dateString)
  const now = new Date()
  const diffInMilliseconds = now - date

  const diffInMinutes = Math.floor(diffInMilliseconds / 60000)
  const diffInHours = Math.floor(diffInMinutes / 60)
  const diffInDays = Math.floor(diffInHours / 24)

  if (diffInDays > 0) {
    const remainingHours = diffInHours % 24
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ${remainingHours} hr${
      remainingHours > 1 ? 's' : ''
    } ago`
  } else if (diffInHours == 0) {
    return `${diffInMinutes} min`
  } else {
    return `${diffInHours} hr${diffInHours > 1 ? 's' : ''} ago`
  }
}

export const timeAgoShort = (dateString) =>{
  const date = new Date(dateString)
  const now = Date.now();
  const diff = (date - now) / 1000;

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto', style: 'short' });

  const ranges = {
    year: 3600 * 24 * 365,
    month: 3600 * 24 * 30,
    week: 3600 * 24 * 7,
    day: 3600 * 24,
    hour: 3600,
    minute: 60,
    second: 1
  };

  for (let key in ranges) {
    if (Math.abs(diff) > ranges[key] || key === "second") {
      return rtf.format(Math.round(diff / ranges[key]), key);
    }
  }
}


export const getContrastingColor = (hexColor) => {
  const r = parseInt(hexColor.slice(1, 3), 16)
  const g = parseInt(hexColor.slice(3, 5), 16)
  const b = parseInt(hexColor.slice(5, 7), 16)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  return brightness > 125 ? 'black' : 'white'
}

export const formatNumber = (amount, showNegativeInParentheses = false) => {
  if (amount !== null && amount !== undefined) {
    // Use the absolute value to format the number
    const formattedNumber = Math.abs(amount)
      .toFixed(2) // Ensure two decimal places
      .replace(/\d(?=(\d{3})+\.)/g, '$&,') // Add commas

    if (amount < 0 && showNegativeInParentheses) {
      // Wrap in parentheses if negative and the option is enabled
      return `(${formattedNumber})`
    } else {
      // Return normally if not negative or parentheses are not desired
      return formattedNumber
    }
  } else {
    return 0
  }
}

export const getLastYearMonths = (month = 6) => {
  const today = new Date()
  const result = []

  for (let i = 0; i < month; i++) {
    const date = new Date(today.getFullYear(), today.getMonth() - i, 1)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0') // Add leading zero for months less than 10
    result.push(`${year}-${month}`)
  }
  return result
}

export const generateId = () => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  const generate = (len, field) => {
    let ans = ''

    let charactersLength = characters.length
    for (let i = 0; i < len; i++) {
      if (field === 'M') {
        let newChar = '12345'
        charactersLength = newChar.length
        ans += newChar.charAt(Math.floor(Math.random() * charactersLength))
      } else if (field === 'N') {
        let newChar = '89ab'
        charactersLength = newChar.length
        ans += newChar.charAt(Math.floor(Math.random() * charactersLength))
      } else {
        ans += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
    }

    return ans
  }

  result = `${generate(8)}-${generate(4)}-${generate(1, 'M')}${generate(
    3,
  )}-${generate(1, 'N')}${generate(3)}-${generate(12)}`

  return result
}



class AudioQueueManager {
  constructor() {
    this.queue = [];
    this.isPlaying = false;
  }

  enqueue(job) {
    this.queue.push(job);
    this.process();
  }

  async process() {
    if (this.isPlaying) return;
    if (this.queue.length === 0) return;

    this.isPlaying = true;
    const job = this.queue.shift();

    try {
      await job();
    } catch (err) {
      console.error('Audio job failed', err);
    }

    this.isPlaying = false;
    this.process(); // play next
  }
}

export const audioQueue = new AudioQueueManager(); // 👈 expose global
